import Header from "../../Layout/Header";
import "./EditProfile.css";
import Profilemenu from "./Profilemenu";
import "./MyAddress.css";
import { useEffect, useState } from "react";
import {
  address,
  billingaddress,
  updateaddress,
  updatebillingaddress,
} from "../../service/Mainservice";
import { useFormik } from "formik";
import Map from "../Customer/Map";

const validate = (values) => {
  const errors = {};
  console.log(values);
  if (!values.SSN) {
    errors.SSN = "Required";
  } else if (values.SSN.length !== 9) {
    errors.SSN = "Must be 9 characters";
  }
  if (!values.DL) {
    errors.DL = "Required";
  }
  return errors;
};

const CAddress = () => {
  const [data, setdata] = useState();
  const [load, setload] = useState();
  const [markerPlace, setmarkerPlace] = useState();
  const [placeerror, setplaceerror] = useState();

  useEffect(() => {
    getaddress();
  }, []);

  const getaddress = async () => {
    try {
      const response = await address();
      setdata(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handlesubmit = async (values) => {
    console.log(markerPlace);
    if (markerPlace === undefined) {
      setplaceerror("Please select address");
    } else if (placeerror) {
      setplaceerror("You need to select valid place");
    } else {
      const { lat, lng } = markerPlace.geometry.location;
      console.log(lat, lng);
      try {
        const data = {
          values,
          billinglat: lat(),
          billinglong: lng(),
          billingaddress: markerPlace.formatted_address,
        };

        const response = await updateaddress(data);
        setload(false);
      } catch (error) {
        console.log(error);
        setload(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      SSN: data?.ssn || "",
      DL: data?.driving_license || "",
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values) => {
      handlesubmit(values);
    },
  });

  return (
    <>
      <Header title="My Addresses" headerbg="addressbg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle"> Address & Identification</h2>

          <form onSubmit={formik.handleSubmit}>
            <div className="Bookcaregiver_inputfield">
              <label htmlFor="address1">Address</label>
              <Map
                setMarkerPlace={setmarkerPlace}
                setplaceerror={setplaceerror}
                defaultLocation={{
                  lat: data?.lat,
                  lng: data?.long,
                  address: data?.address,
                }}
              />

              {placeerror ? (
                <div className="validation_error" style={{ margin: "2px 0" }}>
                  {placeerror}
                </div>
              ) : null}
            </div>
            <div className="Bookcaregiver_inputfield_divs">
              <div className="Bookcaregiver_inputfield">
                <label htmlFor="DL">Driving License</label>
                <input
                  onChange={formik.handleChange}
                  value={formik.values.DL}
                  name="DL"
                  type="text"
                  placeholder="DL"
                  className="Bookcaregiver_input"
                />
                {formik.errors.DL ? (
                  <div className="validation_error" style={{ margin: "2px 0" }}>
                    {formik.errors.DL}
                  </div>
                ) : null}
              </div>

              <div className="Bookcaregiver_inputfield">
                <label htmlFor="SSN">Social Security Number</label>
                <input
                  onChange={formik.handleChange}
                  value={formik.values.SSN}
                  name="SSN"
                  type="text"
                  placeholder="SSN"
                  className="Bookcaregiver_input"
                />
                {formik.errors.SSN ? (
                  <div className="validation_error" style={{ margin: "2px 0" }}>
                    {formik.errors.SSN}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Bookcaregiver_btngrp">
              <button className="Bookcaregiver_button" type="submit">
                {load ? "Loading..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default CAddress;
